$(document).ready(function() {

/*  $(document).on('confirm:complete', function(e){
    console.log(e.detail[0]);
    if (e.detail[0]) {
      return true;
    }
  }); */

  

});
